import { WORKOUT_SECTION_KEY, WORKOUT_SECTION_TYPE } from '../../../model'
import updateWorkoutSectionAction from '../update'
import WORKOUT_SECTIONS_ACTION from '../../constants/action'
import WORKOUT_SECTIONS_ANALYTICS_EVENT from '../../constants/analytics-event'
import { logEventAnalyticsUtil } from '../../../../../utils/analytics/log-event'

export default function convertToCircuitWorkoutSectionAction (id) {
  return (dispatch) => {
    dispatch(updateWorkoutSectionAction({
      type: WORKOUT_SECTIONS_ACTION.CONVERT_TO_CIRCUIT,
      payload: {
        key: WORKOUT_SECTION_KEY.TYPE,
        value: WORKOUT_SECTION_TYPE.CIRCUIT,
        id
      }
    }))
    logEventAnalyticsUtil(WORKOUT_SECTIONS_ANALYTICS_EVENT.CONVERTED_TO_CIRCUIT,
      { id }
    )
  }
}
